import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import {
  ComputersAndVirtualMachinesDataProviderFactory,
} from '../factory/ComputersAndVirtualMachinesDataProviderFactory';
import {
  ComputersAndVirtualMachinesBaseDataProvider,
} from '../dataProvider/ComputersAndVirtualMachinesBaseDataProvider';
import {
  AddExclusionResponse,
  ColumnKeys,
  ComputersAndVirtualMachinesViewData,
  ComputersAndVmItem,
  DeleteRetrieveQuarantineFilePayload,
  DeleteRetrieveQuarantineFileResponse,
  DeleteSelectedPayload,
  DeleteSelectedResponse,
  DownloadSelectedResponse,
  EmptyQuarantinePayload,
  RestoreQuarantinePayload,
  RestoreQuarantineResponse,
  RetrieveQuarantineFilePayload,
  RetrieveQuarantineFileResponse,
  SubmitToLabsFilePayload,
  ValidateQuarantineFilePayload,
  ValidateRetrievePayload,
} from '../types';
import { ReadLicenseUsageDetailsPayload } from '../../../utils/request';
import { ReadLicenseUsageDetailsResponse } from '../../../utils/response';
import { Filter } from '../../../grid/gridFilters/types';

export class ComputersAndVirtualMachinesRepository extends BaseWebComponentRepository {
  public dataProviderFactory: ComputersAndVirtualMachinesDataProviderFactory;
  public dataProvider: ComputersAndVirtualMachinesBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new ComputersAndVirtualMachinesDataProviderFactory(),
    });
  }

  public getDataForView(externalFilters: Filter<ColumnKeys>[]): ComputersAndVirtualMachinesViewData {
    return this.dataProvider.getDataForView(externalFilters);
  }

  public async restoreQuarantine(payload: RestoreQuarantinePayload): Promise<RestoreQuarantineResponse> {
    return this.dataProvider.restoreQuarantine(payload);
  }

  public async deleteSelected(payload: DeleteSelectedPayload): Promise<DeleteSelectedResponse> {
    return this.dataProvider.deleteSelected(payload);
  }

  public async emptyQuarantine(payload: EmptyQuarantinePayload): Promise<DeleteSelectedResponse> {
    return this.dataProvider.emptyQuarantine(payload);
  }

  public async validateRetrieveAction(payload: ValidateRetrievePayload): Promise<void> {
    return this.dataProvider.validateRetrieveAction(payload);
  }

  public async addExclusion(payload: Array<ComputersAndVmItem>): Promise<AddExclusionResponse> {
    return this.dataProvider.addExclusion(payload);
  }

  public async downloadSelected(selectedIds: string): Promise<DownloadSelectedResponse> {
    return this.dataProvider.downloadSelected(selectedIds);
  }

  public async retrieveQuarantineFile(payload: RetrieveQuarantineFilePayload): Promise<RetrieveQuarantineFileResponse> {
    return this.dataProvider.retrieveQuarantineFile(payload);
  }

  /**
   * Delete quarantine archive
   *
   * @param payload
   */
  public async deleteRetrievedQuarantineFile(payload: DeleteRetrieveQuarantineFilePayload): Promise<DeleteRetrieveQuarantineFileResponse> {
    return this.dataProvider.deleteRetrieveQuarantinedFile(payload);
  }

  /**
   * Validate quarantine retrieved file
   *
   * @param payload
   */
  public async validateRetrievedFile(payload: ValidateQuarantineFilePayload): Promise<void> {
    return this.dataProvider.validateRetrievedFile(payload);
  }

  public async readLicenseUsageDetails(payload: ReadLicenseUsageDetailsPayload): Promise<ReadLicenseUsageDetailsResponse> {
    return this.dataProvider.readLicenseUsageDetails(payload);
  }

  public async submitToLabs(payload: SubmitToLabsFilePayload): Promise<void> {
    return this.dataProvider.submitToLabs(payload);
  }
}
